import { render } from "./AmbassadorDashboard.vue?vue&type=template&id=a5961824&ts=true"
import script from "./AmbassadorDashboard.vue?vue&type=script&lang=ts"
export * from "./AmbassadorDashboard.vue?vue&type=script&lang=ts"

import "./AmbassadorDashboard.vue?vue&type=style&index=0&id=a5961824&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__